import Vue from 'vue'
import Vuex from 'vuex'
// import * as actions from './actions';
//  // * 表示将 './actions'模块中的所有接口挂载到actions对象上  as 表示别名的意思
// import * as mutations from './mutations';
// import * as getters from './getters';
// import state from './rootState';
Vue.use(Vuex)
// export default store;
const player = {
  state: {
    playerDisplay: false,
    toUrl: '',
    idNb: '',
    playUrl: '',
    imgUrl: '',
    voiceName: '',
    articles: '',
    loaded: '',
    playing: '',
    paused: '',
    ize: false,
    playnow: false,
    prompts: true
  },
  mutations: {
    CHANGE_PAUSE(state) {
      state.playnow = false
    },
    CHANGE_PLAY_URL(state, url) {
      state.playUrl = url
      state.playnow = true
    }
  },
  actions: {
    SET_PAUSE({ commit }, url) {
      commit('CHANGE_PAUSE')
    },
    SET_PLAY_URL({ commit }, url) {
      commit('CHANGE_PLAY_URL', url)
    },
    SET_PLAY_URL_IOS({ commit }, url) {
      commit('CHANGE_PLAY_URL', url)
    }
  },
  getters: {}
}

const integration = {
  state: {
    count: 4
  },
  mutations: {
    increment(state) {
      state.count++
    }
  },
  actions: {},
  getters: {}
}

const store = new Vuex.Store({
  modules: {
    player: player,
    integration: integration
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js